import React from 'react';
import { Text, HStack, VStack, Container, useDisclosure, Box, } from '@chakra-ui/react';
import BinButton from '../FindingsActionMenu/EditFinding/BinButton';
import { RenderIf } from '../RenderIf/RenderIf';
import { localise } from '../../../services/lang/lang';
import { useTokens } from '../../../context/TokenProvider';
import DeleteNoteModal from './DeleteNoteModal';
import NoteUserDetails from './NoteUserDetails';
const SingleNote = ({ note, canDelete, onNotesMutated }) => {
    const tokens = useTokens();
    const deleteConfirmationModal = useDisclosure();
    return (React.createElement(React.Fragment, null,
        React.createElement(VStack, { "data-testid": "single_note", spacing: tokens.Spacing03, align: "stretch", w: "100%" },
            React.createElement(NoteUserDetails, { note: note }),
            React.createElement(HStack, { spacing: tokens.Spacing04, justifyContent: "space-between", alignItems: "flex-start" },
                React.createElement(Container, { variant: "grey", maxHeight: "132px" },
                    React.createElement(Text, { "data-testid": "single_note__content", variant: "md-600-rg-4" }, note.content)),
                React.createElement(RenderIf, { condition: canDelete },
                    React.createElement(Box, { pr: tokens.Spacing02 },
                        React.createElement(BinButton, { "aria-label": localise('DELETE_NOTE'), onClick: deleteConfirmationModal.onOpen, disabled: deleteConfirmationModal.isOpen }))))),
        React.createElement(RenderIf, { condition: deleteConfirmationModal.isOpen },
            React.createElement(DeleteNoteModal, { onDeleted: () => {
                    deleteConfirmationModal.onClose();
                    onNotesMutated?.();
                }, note: note, onClose: deleteConfirmationModal.onClose }))));
};
export default SingleNote;
